// extracted by mini-css-extract-plugin
export default {"profileComment":"RKFpi7SrFa4vs7lr62vZ"};